export function getErrorMessage(error: any): string {
  // If the error has a nested 'error' object with a 'message'
  if (error?.error?.message) {
    return error.error.message;
  }

  // Fallback to the HttpErrorResponse message
  if (error?.message) {
    return error.message;
  }

  // Fallback to status text
  if (error?.statusText) {
    return error.statusText;
  }

  return 'An unknown error occurred';
}
